import { AnalyticsEvent } from './BaseAnalyticsEvent';
import { type AnalyticsEventName } from './types/AnalyticsEventName';

export class FileShareEvent extends AnalyticsEvent<AnalyticsEventName.FILE_SHARE> {
  constructor(public data: { name: string; url: string; title: string }) {
    super('analytics.share');
  }
}
